import { render, staticRenderFns } from "./studentExamRecordDetails.vue?vue&type=template&id=e3e5f272&scoped=true&"
import script from "./studentExamRecordDetails.vue?vue&type=script&lang=js&"
export * from "./studentExamRecordDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3e5f272",
  null
  
)

export default component.exports